import {BOT_ACTION_INTERVAL_MS} from './botConfig';

/**
 * Шаг между действиями ботов локальной партии для кода ВНЕ React.
 *
 * Шаг знает только BotRunner: скорость ботов игрок выбирает ползунком перед
 * партией, у обучения шаг свой. Сцене он нужен, чтобы анимация действия бота
 * уложилась в паузу до следующего (см. playShotAnimation) — так же, как ей
 * нужна скорость записи матча (utils/replay/replayPlaybackSpeed).
 *
 * Значение держит в актуальном состоянии BotRunner; когда его нет на экране,
 * шаг равен стандартному.
 */
let botActionIntervalMs = BOT_ACTION_INTERVAL_MS;

export const setBotActionIntervalMs = (value) => {
  botActionIntervalMs = Number.isFinite(value) && value > 0 ? value : BOT_ACTION_INTERVAL_MS;
};

export const getBotActionIntervalMs = () => botActionIntervalMs;
